import { SelectInput, TextInput, FormDataConsumer, required } from "react-admin";
import NoArrowKeyNumberInput from "@/components/NoArrowKeyNumberInput";

const typeChoices = [
  { id: "NIYAAZ_FORM", name: "Niyaaz form number" },
  { id: "NIYAAZ_RECEIPT", name: "Niyaaz receipt number" },
];

export const EventSequenceFormFields = ({ showEventId = false }: { showEventId?: boolean }) => (
  <>
    {showEventId && <TextInput source="eventId" fullWidth validate={required()} />}
    <SelectInput source="type" choices={typeChoices} fullWidth validate={required()} />
    <FormDataConsumer>
      {({ formData }) =>
        formData?.type === "NIYAAZ_FORM" ? (
          <TextInput
            source="venueCode"
            label="Jaman venue code"
            fullWidth
            validate={required()}
            helperText="Must match a JAMAN venue code (e.g. JM, FM)"
          />
        ) : null
      }
    </FormDataConsumer>
    <TextInput
      source="prefix"
      label="Prefix"
      fullWidth
      validate={required()}
      helperText="Used in numbers like PREFIX-1447-00001"
    />
    <NoArrowKeyNumberInput
      source="currentValue"
      label="Current value"
      fullWidth
      defaultValue={0}
      helperText="Last issued serial; next number will be current value + 1"
    />
  </>
);
